import React, { useRef, useLayoutEffect } from 'react';
import Konva from 'konva';
import { Rect, Text, Group } from 'react-konva';

export const WellDropInfoPanelTooltip = ({
  text,
  x,
  y,
  visible,
  alignRight = false,
}: {
  text: string;
  x: number;
  y: number;
  visible: boolean;
  alignRight?: boolean;
}) => {
  const tooltipRef = useRef<Konva.Group>(null);

  useLayoutEffect(() => {
    if (tooltipRef.current && visible) {
      tooltipRef.current.moveToTop();
    }
  }, [visible]);

  if (!visible || !text) {
    return null;
  }

  const padding = 8;
  const fontSize = 12;
  const canvas = document.createElement('canvas').getContext('2d');
  canvas.font = `${fontSize}px Arial`;

  // Calculate dimensions for multi-line text
  const lines = text.split('\n');
  let maxWidth = 0;
  lines.forEach((line) => {
    const lineWidth = canvas.measureText(line).width;
    if (lineWidth > maxWidth) {
      maxWidth = lineWidth;
    }
  });

  const textHeight = fontSize * 1.2;
  const lineHeight = textHeight * 1.1;
  const totalTextHeight = lines.length * lineHeight;
  const rectWidth = maxWidth + padding * 2;
  const rectHeight = totalTextHeight + padding * 2;

  // Position tooltip below the panel, aligned to the right if alignRight is true
  const tooltipX = alignRight ? x - rectWidth : x;
  const tooltipY = y + 5; // Position below

  return (
    <Group ref={tooltipRef} x={tooltipX} y={tooltipY}>
      <Rect
        width={rectWidth}
        height={rectHeight}
        fill="#4A4A4A"
        cornerRadius={4}
        shadowBlur={5}
        shadowOffset={{ x: 2, y: 2 }}
        shadowOpacity={0.3}
      />
      {lines.map((line, index) => (
        <Text
          key={index}
          text={line}
          x={padding}
          y={padding + index * lineHeight}
          fontSize={fontSize}
          fontFamily="Arial"
          fill="#FFFFFF"
          align="left"
        />
      ))}
    </Group>
  );
};
